<template>
  <div class="menu">
    <div class="auto_1140 clearfix">
      <div class="fl">
        <ol v-if="lan === 0" @click="isShow = !isShow" :class="{olshow: isShow}">
          <span><a href="javasrcipt:;">您所在位置：{{currentName}}</a></span>
        </ol>
        <ol v-else-if="lan === 1" @click="isShow = !isShow" :class="{olshow: isShow}">
          <span><a href="javasrcipt:;">Location：{{currentEnName}}</a></span>
        </ol>
        <ul class="ul clearfix sub" v-if="lan === 0" :class="{show: isShow}">
          <li v-for="( item, index ) in navList" :key="index" :id='"m" + item.id'>
            <span :class="item.id === area ? 'active' : ''" @click="changeArea(item)">{{item.name}}</span>
          </li>
        </ul>
        <ul class="ul clearfix sub en" v-else-if="lan === 1" :class="{show: isShow}">
          <li v-for="( item, index ) in navList" :key="index" :id='"m" + item.id'>
            <span :class="item.id === area ? 'active' : ''" @click="changeArea(item)">{{item.enName}}</span>
          </li>
        </ul>
      </div>
      <div class="fr">
        <div class="location" v-if="lan === 0">
          <router-link :to="{ name: 'Home', query: { columnId: 38 } }">首页</router-link> · <span class="first" @click="changeArea(navList[0])">{{firstMenu.name}}</span> · <span>{{currentName}}</span>
        </div>
        <div class="location" v-else-if="lan === 1">
          <router-link :to="{ name: 'Home', query: { columnId: 38 } }">Home</router-link> · <span class="first" @click="changeArea(navList[0])">{{firstMenu.enName}}</span> · <span>{{currentEnName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      current: 0,
      firstMenu: [],
      currentName: '',
      currentEnName: '',
      navList: [],
      area: this.$store.state.area,
      lan: this.$store.state.isEn,
      id: this.$route.query.id,
      isShow: false,
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
    },
    '$store.state.area' () {
      this.area = this.$store.state.area
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      // 获取当前页的上级栏目名，以及上级栏目下的所有子栏目
      let menuList = []
      if (localStorage.getItem('routeList') === null) {
        await this.$api.post('api/benefitArticleType/queryByParam', { current: 1, pageSize: 50 }, r => {
          r.data.forEach((item) => {
            let id
            if (item.parentId === 0) {
              menuList.push(item)
              id = item.id
              const children = []
              r.data.forEach((inner) => {
                if (inner.parentId === id) {
                  children.push(inner)
                }
              })
              menuList[menuList.length - 1].children = children
            }
          })
        })
      } else {
        try {
          menuList = JSON.parse(localStorage.getItem('routeList'))
        } catch (err) {
          console.log(err)
        }
      }
      const id = parseInt(this.$route.query.columnId)
      menuList.forEach((item) => {
        if (item.id === id) {
          this.firstMenu = item
          this.navList = item.children
        }
        item.children.forEach((inner) => {
          if (inner.id === this.area || inner.id === parseInt(this.$route.query.articleTypeId)) {
            this.currentName = inner.name
            this.currentEnName = inner.enName
          }
        })
      })
    },
    changeArea (item) {
      this.$store.commit('changeArea', item.id)
      if (typeof (this.id) === 'undefined') {
        // 在列表页点击，就切换内容
        this.init()
        this.currentName = item.name
        this.currentEnName = item.enName
      } else {
        // 在详情页点击，跳转会对应列表页
        this.$router.push({
          path: '/latesttrends',
          query: {
            columnId: 4
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.menu{width: 100%; line-height: 100px; height: 100px; background: #fff; border-radius: 40px 0; box-shadow: 0px 8px 15px 2px rgba(0, 0, 0, 0.1); transform: translateY(-55px);}
.menu .auto_1140{max-width: 1200px;}
.menu .fl{float: left; width: 70%;}
.menu .fr{float: right; width: 30%; text-align: right;}
.menu ol{display: none;}
.menu ol a{color: #333;}
.menu .sub li{float: left; margin-right: 6.5%; line-height: 97px;}
.menu .sub li:last-child{margin-right: 0;}
.menu .sub li span{box-sizing: border-box; display: block; color: #333; font-size: 18px; cursor: pointer; font-weight: lighter;}
.menu .sub li span.active{color: #e4007f; border-bottom: 3px solid #e4007f;}
.menu .en li{margin-right: 3%;}
.menu .en li span{font-size: 17px;}
.menu .sub.en li{margin-right: 2%;}
.menu .sub.en li a{font-size: 15px;}
.menu .location a{padding: 0 10px; font-size: 16px; color: #999; font-weight: lighter;}
.menu .location a:first-child{background: url(../assets/home.png)no-repeat left center; padding-left: 25px;}
.menu .location span{font-size: 16px; color: #999; font-weight: lighter; padding-left: 10px; color: #e4007f;}
.menu .location .first{cursor: pointer; color: #999}
@media(max-width: 1024px){
  .menu .location{display: none;}
  .menu{height: auto; line-height: 80px; overflow: hidden; transform: translateY(-40px);}
  .menu .fl{width: 100%;}
  .menu ol{display: block; margin: 0; padding: 0; cursor: pointer; background: url(../assets/a_down.png)no-repeat right center;}
  .menu .sub{background: rgba(228,0,127,0.1); padding: 0 2%; height: 0; margin: 0 -2%; transition: all .3s;}
  /* .menu:hover .sub{height: auto;}
  .menu:hover ol{background: url(../assets/a_up.png)no-repeat right center;} */
  .menu ol.olshow{background: url(../assets/a_up.png)no-repeat right center;}
  .menu .sub.show{height: auto;}
  .menu .sub li{line-height: 50px; float: none; margin: 0;}
  .menu .sub li.aon a{border: none;}
}
@media(max-width: 640px){
  .menu{border-radius: 30px 0; transform: translateY(-30px);}
  .menu ol{line-height: 60px;}
}
</style>
